import script from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__